/** Exponential backoff with full jitter: never hammer the API in a loop. */
export function backoffDelay(attempt: number, random: () => number = Math.random, baseMs = 4_000, capMs = 5 * 60_000): number {
  const ceiling = Math.min(capMs, baseMs * 2 ** Math.max(0, attempt));
  return Math.round(ceiling / 2 + random() * (ceiling / 2));
}
